
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
    fontSize:'120%'
  },
  newContainer:{
    display: 'flex',
    justifyContent: 'center',
  },
  table: {
    backgroundColor: 'white',
    padding: '1%',
  },

  items: {
    padding: '1%',
    marginLeft: '30px',
    marginTop:5,
    display:'flex',
    flexDirection:'row',
    width:'100%'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '1%',
    width:'40%'
  },

  item_body: {
    padding: '6px ',
    width:'60%'
  },

  main_header: {
    padding: '1%',
    fontSize: '30px',
    textAlign:'center',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    flexDirection:'row',
    paddingTop: '6%',
    fontSize:'20px',
  },
  
  button_view: {
    padding: '1%',
    justifyContent: 'left',
    display: 'flex',
    paddingTop: '2%',
    fontSize:'22px',
  },

  input: {
    width: '50%',
  },
  input_button:{
    backgroundColor: '#21A6DB',
    color:'white',
    borderRadius: '6px',
    marginBottom:'4px',
    marginTop:'4px',
  },
  delete_button:{
    backgroundColor: 'red',
    color:'white',
    borderRadius: '6px',
    marginBottom:'4px',
    marginTop:'4px',
    marginLeft:'10px',
  },

  body_div:{
    fontSize:'18px',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/tournamentCompetition/style.js